import { render, staticRenderFns } from "./PostsTableRow.vue?vue&type=template&id=22730856"
import script from "./PostsTableRow.vue?vue&type=script&lang=js"
export * from "./PostsTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports